export default {
  bgm: 'dear',
  async create () {
  }
}
